import { useModal } from '@components/ModalHook';
import { MODAL_ID as POPUP_ZOOM_IMAGE } from '@components/popup/PopupZoomImage';
import React, { useEffect } from 'react';

const getTagPSourceEndPost = () => {
  // ex:
  // <p style="text-align: right;">
  //   <span style="font-family: arial, helvetica, sans-serif;">Tham khảo từ
  //   <a href="https://www.thinkadvisor.com/" rel="nofollow">ThinkAdvisor&nbsp;
  //   </a>
  //   </span>
  //   </p>
  const elPostContent = document.querySelectorAll('#postContentContainer > div');

  let elTagP = [];
  Array.from(elPostContent).forEach((ele) => {
    const childTagP = ele.getElementsByTagName('p');
    elTagP = elTagP.concat(Array.from(childTagP));
  });

  for (let i = elTagP.length - 1; i > 0; i -= 1) {
    const elP = elTagP[i];
    const elPPre = elTagP[i - 1];

    const elPTextAlign = elP.style.textAlign;
    const elPPreTextAlign = elPPre?.style.textAlign;

    if (elPTextAlign === 'right' && elPPre && elPPreTextAlign !== 'right') {
      return elP;
    }
  }
};

const addTargetBlankTagAExternalLink = () => {
  const postElementA = document.getElementById('vnrPostDetail').getElementsByTagName('a');

  for (let i = 0; i < postElementA.length; i++) {
    const ele = postElementA[i];
    const url = ele.getAttribute('href') || '';
    if (!url.startsWith('https://vnrebates.') && !url.startsWith('/')) {
      ele.setAttribute('target', '_blank');
    }
  }
};

const addRefTagAExternalLink = (disableNoFollowLinks) => {
  let listDoFollow = disableNoFollowLinks.split('\r\n');
  listDoFollow = listDoFollow.map((item) => item.replace('\r\n', '')).filter(Boolean);
  const FIXED_LIST_DO_FOLLOW = ['https://www.okx.com/vi/price/bitcoin-btc'];
  listDoFollow.push(...FIXED_LIST_DO_FOLLOW);
  const checkDoFollowUrl = (url) => {
    if (!url) {
      return false;
    }
    return listDoFollow.some((link) => url.includes(link));
  };

  const lstEleA = document.getElementById('vnrPostDetail').getElementsByTagName('a');
  for (let i = 0; i < lstEleA.length; i++) {
    const ele = lstEleA[i];
    const url = ele.getAttribute('href') || '';

    if (
      !url.startsWith('https://vnrebates.') &&
      !url.startsWith('/') &&
      !url.startsWith('https://wp.vnrebates.io')
    ) {
      ele.setAttribute('rel', 'noreferrer nofollow');
      ele.setAttribute('target', '_blank');
    }

    if (
      !url.startsWith('https://vnrebates.') &&
      !url.startsWith('/') &&
      checkDoFollowUrl(url) &&
      !url.startsWith('https://wp.vnrebates.io')
    ) {
      ele.setAttribute('rel', 'noreferrer');
    }

    if (url.startsWith('https://wp.vnrebates.io')) {
      ele.setAttribute('href', url.replace('https://wp.vnrebates.io', ''));
    }
  }
};

// const addClassNameInternalLink = () => {
//   const lstEleA = document.getElementById("vnrPostDetail").getElementsByTagName("a");
//   for (let i = 0; i < lstEleA.length; i++) {
//     const ele = lstEleA[i];
//     const url = ele.getAttribute('href') || '';
//     if (url.startsWith('https://vnrebates.org')) {
//       ele.classList.add('vnr-link-internal');
//     }
//   }
// };

const replaceTagASourceEndPostToTagSPAN = () => {
  const tagPSource = getTagPSourceEndPost();

  if (!tagPSource) {
    return;
  }

  const listTagA = Array.from(tagPSource.getElementsByTagName('a'));

  listTagA.forEach((ele) => {
    const newSpan = document.createElement('span');
    newSpan.innerHTML = ele.innerHTML;

    ele.replaceWith(newSpan);
  });

  // $(tagPSource)
  //   .find('a')
  // .replaceWith(function () {
  //   return $('<span />', { html: $(this).html() });
  // });
};

const addZoomImage = (showModalZoomImage) => {
  const listElementImage = document
    .getElementById('postContentContainer')
    .getElementsByTagName('img');

  const handleShowModal = (src) => {
    showModalZoomImage({
      src: src,
    });
  };

  for (let i = 0; i < listElementImage.length; i++) {
    const element = listElementImage[i];
    const src = element.getAttribute('src') || '';
    const width = element.getAttribute('width') || 0;

    if (width > 600) {
      element.classList.add('zoom-able-image');
      element.addEventListener('click', () => handleShowModal(src));
    }
  }
};

const addClassNameTrustedSource = (array = []) => {
  const lstEleA = document.getElementById('vnrPostDetail').getElementsByTagName('a');

  for (let i = 0; i < lstEleA.length; i++) {
    const ele = lstEleA[i];
    const url = ele.getAttribute('href');
    if (!url || url === '' || !url.startsWith('http')) {
      continue;
    }
    const urlStr = new URL(url);
    const domain = urlStr.hostname;

    if (array.some((item) => item?.domain.includes(domain))) {
      const domainInfo = array.find((item) => item?.domain.includes(domain));
      ele.innerHTML = `<span>${ele.innerHTML}</span><svg style="bottom: 10px;position: absolute;" xmlns="http://www.w3.org/2000/svg" fill="#02838d" width="12px" height="12px" viewBox="0 0 24 24"><rect x="0" fill="none" width="12" height="12"/><g><path d="M11 17.768l-4.884-4.884 1.768-1.768L11 14.232l8.658-8.658C17.823 3.39 15.075 2 12 2 6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10c0-1.528-.353-2.97-.966-4.266L11 17.768z"/></g></svg>`;
      ele.classList.add('trusted-source');
      const newSpan = document.createElement('span');
      newSpan.classList.add('trusted-source-tooltip');

      const iconDiv = document.createElement('div');
      iconDiv.innerHTML = `<svg style="margin-bottom: -5px;" xmlns="http://www.w3.org/2000/svg" fill="#02838d" width="24px" height="24px" viewBox="0 0 24 24"><rect x="0" fill="none" width="24" height="24"/><g><path d="M11 17.768l-4.884-4.884 1.768-1.768L11 14.232l8.658-8.658C17.823 3.39 15.075 2 12 2 6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10c0-1.528-.353-2.97-.966-4.266L11 17.768z"/></g></svg><a style="padding-left: 5px; text-decoration: underline;color: #02838d" href="https://vnrebates.net/nguon-tham-khao-uy-tin">Trusted Source</a>`;
      const titleDiv = document.createElement('div');
      titleDiv.innerHTML = `<div style="font-size: 22px;font-weight: 700;padding: 20px 0;color: #333333">${
        domainInfo?.name || ''
      }</div>`;
      const descriptionDiv = document.createElement('div');
      descriptionDiv.innerHTML = `<svg fill="#02838d" style="margin-bottom: -3px;" width="18px" height="18px" xmlns="http://www.w3.org/2000/svg" width="1024px" height="1024px" viewBox="0 0 1024 1024">
      <path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"/>
    </svg><span style="padding-left: 5px;color: #333333">${domainInfo?.description || ''}</span>`;
      const sourceDiv = document.createElement('div');
      sourceDiv.style.padding = '15px 0 0';
      sourceDiv.innerHTML = `<span style="color: #02838d;text-decoration: underline;">Go to source</span>`;

      newSpan.appendChild(iconDiv);
      newSpan.appendChild(titleDiv);
      newSpan.appendChild(descriptionDiv);
      newSpan.appendChild(sourceDiv);

      ele.appendChild(newSpan);
    }
  }
};

const removeHeroLCP = () => {
  const buttonElement = document.getElementById('heroLCP');

  if (!buttonElement) return;
  buttonElement.remove();
};

const PostDetailScriptDom = ({ acfOptions }) => {
  const [, showModalZoomImage] = useModal(POPUP_ZOOM_IMAGE);

  useEffect(() => {
    if (typeof window === undefined) {
      return;
    }
    const timeoutLCP = setTimeout(() => {
      removeHeroLCP();
    }, 1000);

    const timeoutSkeleton = setTimeout(() => {
      // addTargetBlankTagAExternalLink();
      addRefTagAExternalLink(acfOptions?.disable_nofollow_linkout);
      // addClassNameInternalLink();
      replaceTagASourceEndPostToTagSPAN();
      addZoomImage(showModalZoomImage);
      addClassNameTrustedSource(acfOptions?.trusted_domain_list);
    }, 1500);

    return () => {
      clearTimeout(timeoutSkeleton);
      clearTimeout(timeoutLCP);
    };
  }, [acfOptions]);

  return <div />;
};

export default PostDetailScriptDom;
